module.exports = __webpack_public_path__ + "static/media/booking4.b8d013ba.jpg";